/* =========================================================
   AMĀRA THEME — wishlist (localStorage, handle-based)
   ========================================================= */
(function () {
  'use strict';

  var KEY = 'amara_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function saveWishlist(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    updateCountBadges();
  }
  function isWishlisted(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }
  function toggleWishlist(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    var added;
    if (idx === -1) { list.push(handle); added = true; }
    else { list.splice(idx, 1); added = false; }
    saveWishlist(list);
    return added;
  }
  function updateCountBadges() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function syncButtonStates() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.dataset.productHandle;
      var active = isWishlisted(handle);
      btn.classList.toggle('is-wishlisted', active);
      btn.setAttribute('aria-pressed', String(active));
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    var handle = btn.dataset.productHandle;
    if (!handle) return;
    var added = toggleWishlist(handle);
    syncButtonStates();
    if (window.themeShowToast) {
      window.themeShowToast(added ? 'Saved to wishlist' : 'Removed from wishlist');
    }
  });

  /* ---------- Render wishlist page ---------- */
  var wishlistGrid = document.querySelector('[data-wishlist-grid]');
  var wishlistEmpty = document.querySelector('[data-wishlist-empty]');
  if (wishlistGrid) {
    var handles = getWishlist();
    if (!handles.length) {
      wishlistGrid.hidden = true;
      if (wishlistEmpty) wishlistEmpty.hidden = false;
    } else {
      Promise.all(handles.map(function (handle) {
        return fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        products = products.filter(Boolean);
        if (!products.length) {
          wishlistGrid.hidden = true;
          if (wishlistEmpty) wishlistEmpty.hidden = false;
          return;
        }
        wishlistGrid.innerHTML = products.map(function (p) {
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var price = window.themeFormatMoney ? window.themeFormatMoney(p.price) : p.price;
          return '<div class="product-card" data-product-card>' +
            '<div class="product-card__media-wrap">' +
            '<a href="' + p.url + '" class="product-card__media"><img class="product-card__image product-card__image--primary" src="' + img + '" alt="' + p.title + '" loading="lazy"></a>' +
            '<button type="button" class="product-card__wishlist is-wishlisted" data-wishlist-toggle data-product-handle="' + p.handle + '" aria-label="Remove from wishlist">✕</button>' +
            '</div>' +
            '<div class="product-card__info"><h3 class="product-card__title"><a href="' + p.url + '">' + p.title + '</a></h3>' +
            '<div class="price"><span class="price__regular">' + price + '</span></div></div></div>';
        }).join('');
        wishlistGrid.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-wishlist-toggle]');
          if (!btn) return;
          setTimeout(function () {
            var card = btn.closest('[data-product-card]');
            if (card && !isWishlisted(btn.dataset.productHandle)) card.remove();
            if (!getWishlist().length) {
              wishlistGrid.hidden = true;
              if (wishlistEmpty) wishlistEmpty.hidden = false;
            }
          }, 10);
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncButtonStates();
    updateCountBadges();
  });
  syncButtonStates();
  updateCountBadges();
})();
